export const FINANCING_ENDING_END_DATE_PERIOD = 'endDate';
